<div class="bg-slate-100 h-screen flex items-center justify-center">
    <div
      class="flex flex-col items-center w-90 max-w-md px-6 py-8 bg-white rounded-lg shadow h-fit"
    >
    <a href="#" class="mt-20 flex items-center justify-center mb-6 text-2xl font-semibold text-black">
      <img class=" w-auto max-w-[200px]" src="../../../assets/images/mav_logo.png" alt="logo">
    </a>
      <div class="flex w-80 flex-col gap-9">
        <h1
          class="text-xl font-thin leading-tight tracking-tight text-black md:text-2xl flex w-full justify-center items-centers"
        >
          Iniciar sesión
        </h1>
        <form
          class="flex flex-col items-center justify-center w-full gap-4"
          action="#"
        >
          <div class="w-full flex flex-col gap-2">
            <label type="email" for="email" class="text-sm font-bold text-black"
              >Ingresar email</label
            >
            <input
              type="email"
              name="email"
              id="email"
              class="border bg-transparent border-gray-300 text-black sm:text-lg rounded-lg block w-full p-2.5"
              placeholder="usuario@dominio.com"
              required=""
              [(ngModel)]="email"
            />
          </div>
          <div class="w-full flex flex-col gap-2">
            <label type="password" for="password" class="text-sm font-bold text-black"
              >Ingresar contraseña</label
            >
            <input
              type="password"
              name="password"
              id="password"
              placeholder="*********"
              class="border bg-transparent border-gray-300 text-black sm:text-sm rounded-lg block w-full p-2.5"
              required=""
              [(ngModel)]="password"
            />
          </div>
          <!-- <div class="flex flex-col gap-4 items-center justify-between">
            <div class="flex items-start"></div>
            <a href="#" class="text-xs -mt-5 font-bold hover:underline text-blue-500"
              >¿Olvidaste tu contraseña?</a
            >
          </div> -->
          <div class="flex flex-col items-center justify-center gap-4 w-full">
            <button
              type="button"
              (click)="login()"
              [disabled]="isLoading"
              class="w-full text-white bg-slate-500 hover:bg-slate-600 disabled:bg-slate-400 disabled:cursor-not-allowed focus:ring-4 focus:outline-none focus:ring-slate-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center gap-2 transition-all duration-200"
            >
              <div *ngIf="isLoading" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              <span>{{ isLoading ? 'Iniciando sesión...' : 'Iniciar sesión' }}</span>
            </button>
  
            <!-- Mensajes de error específicos -->
            <div *ngIf="loginError && errorType === 'credentials'" class="text-red-500 text-sm bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
              <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              <span>{{ errorMessage }}</span>
            </div>

            <div *ngIf="loginError && errorType === 'connection'" class="text-orange-500 text-sm bg-orange-50 border border-orange-200 rounded-lg p-3 flex items-center gap-2">
              <svg class="w-4 h-4 text-orange-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
              </svg>
              <span>{{ errorMessage }}</span>
            </div>

            <div *ngIf="loginError && errorType === 'server'" class="text-red-500 text-sm bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
              <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
              </svg>
              <span>{{ errorMessage }}</span>
            </div>
  
            <div *ngIf="showGoogleLoginError" class="text-red-500 text-sm bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
              <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
              <span>Error al iniciar sesión con Google.</span>
            </div>
          </div>
          <!-- <a id="google-login-button">Iniciar sesión con Google</a> -->
  
          <!-- <div class="flex flex-col items-center gap-4">
            <p class="text-sm font-bold text-black w-full justify-around flex">
              Aún no tienes cuenta?
            </p>
            <a
              href="/sign-up"
              class="-mt-6 mb-12 w-full text-white bg-pink-400 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >Registrarse</a
            >
          </div> -->
        </form>
      </div>
    </div>
  </div>
  